<template>
  <div class="validate-user" :class="state.type">
    <div class="title-img" :class="state.locale"></div>
    <div class="form" v-if="!state.cpUserInfo.cpUserId || !state.cpUserInfo.token">
      <div class="form-item">
        <div class="form-item-label user-id" @click="openUserGuide">
          <i class="icon-question"></i>
          {{ $t('payment.validateUser.desc') }}
        </div>
        <div class="form-item-input">
          <HistoryUserIdInput
            v-model="state.userId"
            :locale="state.locale"
            :placeholder="$t('payment.validateUser.enterUserId')"
          />
        </div>
        <div class="form-item-button">
          <PPButton type="blue" @click="handleActSubmit('poolParty')">{{ $t('payment.validateUser.submit') }}</PPButton>
        </div>
      </div>
    </div>
    <div class="validate-user-success" v-else>
      <div class="user-info">
        <div class="user-info-item">
          <span class="user-info-item-label">
            {{ $t('payment.userDialog.id') }}: 
          </span>
          <span class="user-info-item-value">
            {{ state.cpUserInfo.cpUserId }}
          </span>
        </div>
        <div class="user-info-item">
          <span class="user-info-item-label">
            {{ $t('payment.userDialog.name') }}: 
          </span>
          <span class="user-info-item-value">
            {{ state.cpUserInfo.cpNickName }}
          </span>
        </div>
      </div>
      <PPButton class="cancel-btn" type="blue" @click="resetUserInfo">{{ $t('payment.userDialog.cancelInput') }}</PPButton>
    </div>
    <Dialog v-model="state.dialog.visible" :title="$t('poolParty.loginDialog.title')">
      <div class="dialog-content">
        <div class="info">
          <div class="info-item">
            <div class="info-item-label">
              {{ $t('payment.userDialog.id') }}: 
            </div>
            <div class="info-item-value">
              {{ state.tempCpUserInfo.cpUserId }}
            </div>
          </div>
          <div class="info-item">
            <div class="info-item-label">
              {{ $t('payment.userDialog.name') }}: 
            </div>
            <div class="info-item-value">
              {{ state.tempCpUserInfo.cpNickName }}
            </div>
          </div>
        </div>
        <div class="desc">
          {{ $t('payment.userDialog.confirmText') }}
        </div>
        <div class="btn-box">
          <PPButton type="blue" @click="handleConfirm">{{ $t('payment.userDialog.confirmInput') }}</PPButton>
          <PPButton type="green" @click="handleCancel">{{ $t('payment.userDialog.cancelInput') }}</PPButton>
        </div>
      </div>
    </Dialog>
    <div v-if="state.showImageViewer">
      <el-image-viewer
        v-if="state.showImageViewer"
        hide-on-click-modal
        :url-list="state.imageList"
        :initial-index="0"
        :z-index="9999"
        teleported
        @close="closeImageViewer"
      />
    </div>
  </div>
</template>

<script setup>
import { defineExpose } from 'vue'
import useValidateUser from '../script'
import HistoryUserIdInput from '../HistoryUserIdInput/index.vue'
import Dialog from '@/components/Dialog/ActPoolParty'
import PPButton from '@/views/act/poolParty/components/PPButton/index.vue'
import { ElImageViewer } from 'element-plus'
import { defineEmits } from 'vue'
const emit = defineEmits(['resetUserInfo', 'getUserInfoSuccess'])
const { state, handleActSubmit, handleConfirm, handleCancel, resetUserInfo, openUserGuide, closeImageViewer, setUserId } = useValidateUser(emit, 'poolParty')

defineExpose({
  setUserId,
  handleActSubmit
})
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>
